module.exports = __webpack_public_path__ + "img/yqh.744f4006.svg";